import * as React from "react";
type Props = {
  className?: string,
};
function SvgNew({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-new"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9748 10.4445V11.2504H11.1793V12.0919H12.8148V12.8622H11.1793V13.7867H12.9808V14.5926H10.3022V10.4445H12.9748ZM14.3496 10.4445L14.9067 13.1763H14.9185L15.6771 10.4445H16.483L17.2415 13.1763H17.2534L17.8104 10.4445H18.7052L17.8282 14.5926H16.8978L16.0859 11.7482H16.0741L15.2622 14.5926H14.3378L13.4548 10.4445H14.3496ZM7.01335 10.4445L8.4178 13.0815H8.42965V10.4445H9.30668V14.5926H8.40594L7.0015 11.9556H6.98965V14.5926H6.11261V10.4445H7.01335Z"
        fill="white"
      />
    </svg>
  );
}
export default SvgNew;
